import React from 'react';
import * as PropTypes from 'prop-types';
import grey from '@material-ui/core/colors/grey';
import orange from '@material-ui/core/colors/orange';
import { withStyles } from '@material-ui/core';
import TranslateIcon from '@material-ui/icons/Translate';
import MIconButton from './iconButton';

const styles = () => ({
  buttonTranslate: {
    // backgroundColor: grey[50],
    // color: grey[500],
    '&:hover': {
      backgroundColor: grey[100],
      color: orange[900],
    },
  },
});

const TranslateButton = ({ classes, onClick, ...others }) => (
  <MIconButton {...others} onClick={onClick} className={classes.buttonTranslate}>
    <TranslateIcon fontSize="small" />
  </MIconButton>
);

TranslateButton.defaultProps = {
  onClick: null,
};

TranslateButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default withStyles(styles)(TranslateButton);
